import { Trace, TraceReturn } from '../types';

export type ReturnStatusValue = 'pending' | 'confirmed' | 'failed' | string | undefined;

export const getReturnStatusTagColor = (
  status: ReturnStatusValue,
): 'processing' | 'success' | 'error' | 'default' => {
  if (status === 'pending') {
    return 'processing';
  }
  if (status === 'confirmed') {
    return 'success';
  }
  if (status === 'failed') {
    return 'error';
  }
  return 'default';
};

export const getProcessingStatusTagColor = (
  status: string | undefined,
): 'success' | 'warning' | 'processing' | 'default' => {
  if (!status) {
    return 'default';
  }
  const normalized = status.toLowerCase();
  if (normalized === 'traité' || normalized === 'traite' || normalized === 't') {
    return 'success';
  }
  if (normalized === 'non traité' || normalized === 'non traite') {
    return 'warning';
  }
  if (normalized === 'pending') {
    return 'processing';
  }
  return 'default';
};

export const resolveProcessingStatus = (
  record: Partial<Trace> & Partial<TraceReturn>,
): string | undefined => {
  const raw = record.ceco ?? record.eurekaStatus;
  if (!raw) {
    return undefined;
  }
  if (raw === 'pending') {
    return 'pending';
  }
  if (raw === 'unavailable') {
    return 'unavailable';
  }
  return String(raw);
};

export const formatProcessingStatusLabel = (
  status: string | undefined,
  labels: Record<string, string>,
): string => {
  if (!status) {
    return '';
  }
  return labels[status] || status;
};
